import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import 'slick-carousel';
//import App from 'resizement/scripts/resize';

Snappy.Component.MediaGallery = class MediaGallery extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-media-gallery';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();

        this.init();
    }

    setVars() {
        this.mainCarouselNode = this.$element.find('.js-mg-main-carousel');
        this.navCarouselNode = this.$element.find('.js-mg-nav-carousel');
        this.navArrowsNode = this.$element.find('.js-mg-nav-arrows');

    }

    setEventListeners() {
    }

    init() {
        //debugger;
        this.mainCarouselNode.slick({
            asNavFor: this.navCarouselNode,
            touchThreshold: 10,
            arrows: false
        });
        this.navCarouselNode.slick({
            asNavFor: this.mainCarouselNode,
            slidesToShow: 4,
            slidesToScroll: 1,
            focusOnSelect: true,
            touchThreshold: 10,
            appendArrows: this.navArrowsNode,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ],
            prevArrow: `<button type="button" class="slick-prev" title="Previous Slide" aria-label="Previous Slide">
                            <svg class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">
                                <use  xlink:href="#icon-chevron-left"></use>
                            </svg>
                        </button>`,
            nextArrow: `<button type="button" class="slick-next" title="Next Slide" aria-label="Next Slide">
                            <svg class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">
                                <use  xlink:href="#icon-chevron-right"></use>
                            </svg>
                        </button>`

        });

        this.navCarouselNode.on('beforeChange', function(){
            $(document).trigger('responsiveVideo:stopVideo');
        });
    }
};



// WEBPACK FOOTER //
// ./components/media-gallery/scripts/media-gallery.js